import { jsxs as v, jsx as d } from "react/jsx-runtime";
import { lazy as _, useState as S, Suspense as R } from "react";
import { M as y } from "./MaterialSymbol-hT2awJjQ.js";
import { e as T, R as x, S as E, f as C, h as N, j as k, k as D } from "./trackerSavedViews-B1fUFnV-.js";
const g = () => import("./CustomSelectPopover-BD8Xa18y.js"), O = _(
  () => g().then((s) => ({
    default: s.CustomSelectPopover
  }))
), z = ({
  value: s,
  options: c,
  onChange: p,
  placeholder: b = "Select...",
  required: r = !1
}) => {
  const [a, u] = S(!1), [f, e] = S(null), t = c.find((o) => o.value === s), n = (o) => {
    p(o), u(!1);
  };
  return /* @__PURE__ */ v(
    "div",
    {
      className: "custom-select relative inline-block w-full",
      onBlur: (o) => {
        o.currentTarget.contains(o.relatedTarget) || u(!1);
      },
      children: [
        /* @__PURE__ */ v(
          "button",
          {
            ref: e,
            type: "button",
            className: "custom-select-trigger flex items-center justify-between w-full py-1.5 px-2 bg-[var(--nim-bg-secondary)] border border-[var(--nim-border)] rounded text-[13px] text-[var(--nim-text)] cursor-pointer transition-all duration-150 hover:bg-[var(--nim-bg-hover)] hover:border-[var(--nim-primary)] focus:outline-none focus:border-[var(--nim-primary)] focus:shadow-[0_0_0_2px_rgba(59,130,246,0.1)]",
            onClick: () => u((o) => !o),
            onPointerEnter: () => {
              g();
            },
            onFocus: () => {
              g();
            },
            onPointerDown: () => {
              g();
            },
            "aria-haspopup": "listbox",
            "aria-expanded": a,
            children: [
              t ? /* @__PURE__ */ v("span", { className: "custom-select-value flex items-center gap-1.5 flex-1", children: [
                t.icon && /* @__PURE__ */ d(y, { icon: t.icon, size: 16 }),
                /* @__PURE__ */ d("span", { children: t.label })
              ] }) : s ? (
                // The stored value isn't in the current options (an override removed/
                // renamed it, or a peer set it on a different schema). Render it neutrally
                // so the value stays visible and editable instead of silently vanishing.
                /* @__PURE__ */ v(
                  "span",
                  {
                    className: "custom-select-value custom-select-value-unknown flex items-center gap-1.5 flex-1 text-[var(--nim-text-secondary)]",
                    title: `Unrecognized option: ${s}`,
                    children: [
                      /* @__PURE__ */ d(y, { icon: "help_outline", size: 16 }),
                      /* @__PURE__ */ d("span", { children: String(s) })
                    ]
                  }
                )
              ) : /* @__PURE__ */ d("span", { className: "custom-select-placeholder text-[var(--nim-text-faint)]", children: b }),
              /* @__PURE__ */ d(
                y,
                {
                  icon: a ? "expand_less" : "expand_more",
                  size: 16
                }
              )
            ]
          }
        ),
        a && f && /* @__PURE__ */ d(R, { fallback: null, children: /* @__PURE__ */ d(
          O,
          {
            reference: f,
            value: s,
            options: c,
            required: r,
            onSelect: n
          }
        ) })
      ]
    }
  );
}, F = /* @__PURE__ */ new Map([
  ["title", 0],
  ["workflowStatus", 1],
  ["priority", 2],
  ["assignee", 3],
  ["reporter", 4],
  ["tags", 5],
  ["progress", 6],
  ["startDate", 7],
  ["dueDate", 8]
]), h = /* @__PURE__ */ new Map([
  ["type", 20],
  ["key", 21],
  ["updated", 22],
  ["viewed", 23],
  ["created", 24],
  ["createdBy", 25],
  ["updatedBy", 26],
  ["module", 27],
  ["shared", 28],
  ["favorite", 29],
  ["archived", 30]
]);
function B(s, c, p) {
  const r = [...s].sort((e, t) => {
    const n = e.role ? F.get(e.role) ?? 15 : h.get(e.id) ?? 10, l = t.role ? F.get(t.role) ?? 15 : h.get(t.id) ?? 10;
    return n - l || e.label.localeCompare(t.label);
  }).map((e) => {
    const t = T(c, e.id), n = e.role ? p.map((o) => {
      const i = o.roles?.[e.role];
      return i ? o.fields.find((w) => w.name === i) : void 0;
    }).filter((o) => o !== void 0) : [], l = t ?? n[0], m = /* @__PURE__ */ new Map();
    for (const o of t ? [t] : n)
      for (const i of o.options ?? [])
        m.set(i.value, {
          label: i.label,
          color: i.color,
          icon: i.icon
        });
    return e.id === "shared" ? {
      id: e.id,
      label: e.label,
      type: "select",
      group: "system",
      options: [
        { value: "draft", label: "Draft" },
        { value: "published", label: "Published" }
      ]
    } : e.id === "type" ? {
      id: e.id,
      label: e.label,
      type: "select",
      group: "system",
      options: p.map((o) => ({ value: o.type, label: o.displayName }))
    } : {
      id: e.id,
      label: e.label,
      group: e.role ? "common" : h.has(e.id) ? "system" : "custom",
      type: l?.type ?? (e.render === "date" ? "date" : e.render === "tags" ? "array" : e.render === "avatar" ? "user" : m.size > 0 ? "select" : "string"),
      multiValue: l?.multiValue,
      options: m.size > 0 ? Array.from(m, ([o, i]) => ({ value: o, ...i })) : l?.options
    };
  });
  r.some((e) => e.id === "owner" || s.some(
    (t) => t.id === e.id && t.role === "assignee"
  )) || r.splice(Math.min(3, r.length), 0, {
    id: "owner",
    label: "Owner",
    type: "user",
    group: "common"
  }), r.some((e) => e.id === "favorite") || r.push({
    id: "favorite",
    label: "Starred",
    type: "boolean",
    group: "system",
    options: [
      { value: "true", label: "Yes" },
      { value: "false", label: "No" }
    ]
  }), r.some((e) => e.id === "archived") || r.push({ id: "archived", label: "Archived", type: "boolean", group: "system" }), r.some((e) => e.id === x) || r.push({
    id: x,
    label: "Readiness",
    type: "select",
    group: "system",
    options: [
      { value: "ready", label: "Ready" },
      { value: "blocked", label: "Blocked" },
      { value: "closed", label: "Closed" }
    ]
  });
  const a = /* @__PURE__ */ new Map();
  for (const e of p) {
    const t = e.roles?.workflowStatus, n = t ? e.fields.find((l) => l.name === t) : void 0;
    for (const l of n?.options ?? [])
      a.set(l.value, {
        value: l.value,
        label: l.label,
        color: l.color,
        icon: l.icon
      });
  }
  const u = [
    {
      id: E,
      label: "Status changed to",
      type: "select",
      group: "common",
      options: Array.from(a.values())
    },
    {
      id: C,
      label: "Status changed from",
      type: "select",
      group: "common",
      options: Array.from(a.values())
    }
  ], f = r.findIndex((e) => s.some(
    (t) => t.id === e.id && t.role === "workflowStatus"
  ));
  return r.splice(f >= 0 ? f + 1 : Math.min(1, r.length), 0, ...u), r;
}
function P(s, c, p, b) {
  const r = p.find((a) => a.id === c)?.role;
  return r ? N(s, k(s.primaryType, r)) : D(s, c, b);
}
export {
  z as C,
  B as c,
  P as g
};
//# sourceMappingURL=createTrackerFilterFields-DFU8FW1n.js.map
